export default __webpack_public_path__ + "static/media/Turismo, Gestão Hoteleira e Animação.83fca52c.pdf";